import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WordprocessorBackendService {

  private env = '';
  private url = '';

  constructor(private http: HttpClient) { }

  private initialize() {
    if (this.env === '') {
      if (
        (window as any).location.hostname.indexOf('localhost') >= 0 ||
        (window as any).location.hostname.indexOf('dev') >= 0 ||
        (window as any).location.hostname.indexOf('test') >= 0
      ) {
        this.env = 'test';
      } else {
        this.env = 'prod';
      }
      console.log(`WordprocessorBackendService: using backend ${this.env}`);
      this.url = `https://${this.env}-dot-syncfusion-converters.ey.r.appspot.com/api/wordeditor`;
    }
  }

  loadDocx(blob: Blob, filename: string): Observable<string> {
    this.initialize();
    const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/octet-stream', 'X-Filename': filename });
    return this.http.post(`${this.url}/import-docx`, blob, { headers, responseType: 'text' })
  }

  loadHtml(blob: Blob, filename: string): Observable<string> {
    this.initialize();
    const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/octet-stream', 'X-Filename': filename });
    return this.http.post(`${this.url}/import-html`, blob, { headers, responseType: 'text' })
  }

  exportDocx(blob: Blob): Observable<Blob> {
    this.initialize();
    const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json;charset=UTF-8' });
    return this.http.post(`${this.url}/convert-to-docx`, blob, { headers, responseType: 'blob' });
  }

  htmlToDocx(blob: Blob): Observable<Blob> {
    this.initialize();
    const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json;charset=UTF-8' });
    return this.http.post(`${this.url}/html-to-docx`, blob, { headers, responseType: 'blob' });
  }

  convertToHtml(text: string): Observable<string> {
    this.initialize();
    const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json;charset=UTF-8' });
    return this.http.post(`${this.url}/convert-to-html`, text, { headers, responseType: 'text' });

  }

}
